module.exports = __webpack_public_path__ + "img/mendian-hover.ed993a9f.png";